import { LogoMark } from '@cbhq/cds-web/icons/LogoMark';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { useGlobalMicrocopy } from '../../providers/MicrocopyProvider.js';
import '../../ui/Div/index.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import { createListRichTextOptions } from '../../ui/RichText/options/listRichTextOptions.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Text } from '../../ui/Text.js';
import { formatDateWithoutTimeZone } from '../../utils/formatDateWithoutTimeZone.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HeroFeaturedEditorialContent({
  eyebrow,
  hasEyebrowIcon = false,
  headline,
  excerpt,
  list,
  legalText,
  categoryTagLabel,
  categoryTagUrl,
  readTime,
  publicationDate: date,
  url,
  layout,
  style
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    primary = _componentsThemeMap$s.primary;
  const microcopies = useGlobalMicrocopy();
  return /*#__PURE__*/jsxs(Div, {
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    spacingStart: layout === 'right' ? {
      lg: 4
    } : undefined,
    spacingEnd: layout === 'left' ? {
      lg: 4
    } : undefined,
    spacingTop: 5,
    spacingBottom: {
      lg: 5
    },
    minHeight: {
      lg: 420
    },
    children: [/*#__PURE__*/jsx(LinkPressable, {
      href: url || '',
      "data-qa": ANALYTICS_KEY.Content,
      children: /*#__PURE__*/jsxs(Fragment, {
        children: [!!eyebrow && /*#__PURE__*/jsxs(Div, {
          css: {
            gap: '8px'
          },
          children: [hasEyebrowIcon && /*#__PURE__*/jsx(LogoMark, {
            size: 16
          }), /*#__PURE__*/jsx(Text, {
            variant: "label2",
            as: "p",
            color: foregroundSecondary,
            children: eyebrow
          })]
        }), /*#__PURE__*/jsx(Text, {
          as: "h1",
          css: {
            margin: 0
          },
          color: foreground,
          spacingTop: {
            sm: 1,
            md: 2,
            lg: 3
          },
          variant: {
            sm: 'title2',
            lg: 'display3'
          },
          children: headline
        }), excerpt && /*#__PURE__*/jsx(Text, {
          as: "p",
          variant: "body",
          spacingTop: 1,
          css: {
            margin: 0
          },
          color: foregroundSecondary,
          children: excerpt
        }), list && /*#__PURE__*/jsx(Div, {
          css: {
            display: 'contents',
            p: {
              color: colorToVariable(foregroundSecondary)
            }
          },
          children: /*#__PURE__*/jsx(RichText, {
            content: list,
            richTextOptions: createListRichTextOptions(),
            color: foregroundSecondary
          })
        }), legalText && /*#__PURE__*/jsx(Text, {
          as: "p",
          variant: "legal",
          css: {
            margin: 0
          },
          color: foregroundSecondary,
          spacingTop: {
            sm: 3,
            lg: 5
          },
          children: legalText
        })]
      })
    }), /*#__PURE__*/jsxs(Div, {
      spacingTop: 3,
      gap: 1,
      alignItems: "center",
      children: [categoryTagLabel && (categoryTagUrl ? /*#__PURE__*/jsx(LinkPressable, {
        href: categoryTagUrl || '',
        "data-qa": ANALYTICS_KEY.CategoryTag,
        children: /*#__PURE__*/jsxs(Text, {
          as: "p",
          variant: "legal",
          color: primary,
          css: {
            textDecoration: 'underline',
            margin: 0
          },
          children: [categoryTagLabel, (date || readTime) && ',']
        })
      }) : /*#__PURE__*/jsxs(Text, {
        as: "p",
        variant: "legal",
        color: foreground,
        css: {
          margin: 0
        },
        children: [categoryTagLabel, (date || readTime) && ',']
      })), date && /*#__PURE__*/jsxs(Text, {
        variant: "legal",
        as: "p",
        color: foregroundSecondary,
        children: [formatDateWithoutTimeZone(date, {
          month: 'short',
          year: 'numeric',
          day: 'numeric'
        }), readTime && ',']
      }), readTime && /*#__PURE__*/jsxs(Text, {
        variant: "legal",
        as: "p",
        color: foregroundSecondary,
        children: [readTime, " ", microcopies.global.readTime]
      })]
    })]
  });
}
export { HeroFeaturedEditorialContent };
//# sourceMappingURL=Content.js.map
